<template>
  <div class="parent">

    <!-- En-tête -->
    <div class="header">
      <img class="logo" src="../assets/logogth.png" alt="Logo GTHCONSULT"/>
      <div class="titre">QUESTIONNAIRE DE SATISFACTION CLIENT</div>
      <ul class="reference">
        <li>Référence : F.PS.01.04</li>
        <li>Version : 03</li>
        <li>Date : 02/04/2025</li>
        <li>Page : 1/1</li>
      </ul>
    </div>

    <div class="barr"></div>

    <!-- Introduction -->
    <div class="itresse">
      <h3>Votre avis nous intéresse!</h3>
      <p>Chez <span class="gthconsult">GTHCONSULT</span>, nos clients sont au cœur de nos préoccupations. Nous vous remercions sincèrement de</p>
      <p>prendre quelques instants pour compléter ce questionnaire. Vos réponses nous aideront à façonner des solutions adaptées à vos besoins.</p>
      <p><span class="gthconsult">GTHCONSULT</span> vous remercie pour votre contribution.</p>
    </div>

    <div class="barr"></div>

    <!-- Infos client -->
    <ul class="client">
      <p>Veuillez remplir les informations suivantes</p>
      <li>
        Société
        <input type="text" :value="raisonSocial" disabled>
      </li>
      <li>
        Secteur d’activité
        <select v-model="secteurActivite">
          <option v-for="item in secteurs" :value="item" :key="item">{{ item }}</option>
        </select>
      </li>
      <li>
        Nom de l’évaluateur (obligatoire)
        <input type="text" v-model="nomEvaluateur">
      </li>
      <li>
        Prénom de l’évaluateur (obligatoire)
        <input type="text" v-model="prenomEvaluateur">
      </li>
      <li>
        Fonction (facultatif)
        <input type="text" v-model="fonctionEvaluateur">
      </li>
      <li>
        N° de Téléphone (facultatif)
        <input type="text" v-model="telephoneEvaluateur">
      </li>
      <li>
        Email de l’évaluateur (facultatif)
        <input type="email" v-model="emailEvaluateur" disabled>
      </li>
      <li>
        Lieu (facultatif)
        <input type="text" v-model="lieuEnvoyer">
      </li>
      <li>
        Date (facultatif)
        <input type="date" v-model="dateEnvoyer">
      </li>
      <li>
        Par quel moyen avez-vous trouvé GTHCONSULT ?
        <select v-model="source">
          <option v-for="item in sources" :value="item" :key="item">{{ item }}</option>
        </select>
        <!-- Champ "Autre" pour la source -->
        <input v-if="source === 'Autre'" type="text" v-model="sourceAutre" placeholder="Précisez votre source">
      </li>
      <li>
        Quels types de prestations avez-vous bénéficié de la part de GTHCONSULT ?
      </li>
      <li>
        <table id="customers">
          <tr v-for="(item, index) in prestations" :key="index">
            <td>
              <input type="checkbox" v-model="prestations[index].value">
            </td>
            <td>{{ item.text }}</td>
          </tr>
          <!-- Si la prestation "Autre" est sélectionnée, on affiche un champ pour préciser -->
          <tr v-if="prestationAutreSelected">
            <td colspan="2">
              <input type="text" v-model="autrePrestationDetail" placeholder="Précisez votre prestation">
            </td>
          </tr>
        </table>
      </li>
    </ul>

    <!-- Évaluation de l'attachement -->
    <div class="barr-question">I - Évaluation du degré d'attachement de nos clients</div>
    <p class="question-recommander">Quel est votre degré de satisfaction global par rapport à GTHCONSULT ?</p>
    <p class="question-degre">Veuillez choisir votre réponse ci-dessous</p>
    <div class="echelle">
      <li :class="isDefaultButtonColorRecommandation" @click="changeColorRecommandation">Satisfait</li>
      <li :class="isDefaultButtonColorNeutre" @click="changeColorNeutre">Moyennement satisfait</li>
      <li :class="isDefaultButtonColorPasRecommandation" @click="changeColorPasRecommandation">Non satisfait</li>
    </div>

    <!-- Recommandation entreprise -->
    <p class="question-recommander">Recommanderiez-vous GTHCONSULT à d’autres entreprises ?</p>
    <p class="question-degre">Veuillez choisir votre réponse ci-dessous</p>
    <div class="echelle">
      <li :class="isDefaultButtonColorRecommandationEntreprise" @click="changeColorRecommandationEntreprise">Oui</li>
      <li :class="isDefaultButtonColorNeutreEntreprise" @click="changeColorNeutreEntreprise">Peut-être</li>
      <li :class="isDefaultButtonColorPasRecommandationEntreprise" @click="changeColorPasRecommandationEntreprise">Non</li>
    </div>

    <!-- Évaluation détaillée -->
    <div class="barr-question">II - Évaluation du niveau de satisfaction de nos clients</div>
    <p class="question-degre">Veuillez choisir un seul choix par question</p>
    <table id="customers">
      <tr>
        <th>Les questions</th>
        <th>Non satisfait</th>
        <th>Moyennement satisfait</th>
        <th>Satisfait</th>
      </tr>
      <tr v-for="item in questions" :key="item.id">
        <td>{{ item.question }}</td>
        <td>
          <input type="radio" :name="'question-' + item.id" v-model="item.note" value="Non satisfait">
        </td>
        <td>
          <input type="radio" :name="'question-' + item.id" v-model="item.note" value="Moyennement satisfait">
        </td>
        <td>
          <input type="radio" :name="'question-' + item.id" v-model="item.note" value="Satisfait">
        </td>
      </tr>
    </table>

    <!-- Commentaires -->
    <div class="barr-question">Commentaires et Suggestions</div>
    <div class="commentaires">
      <p>Avez-vous des suggestions ou des commentaires pour améliorer nos prestations ?</p>
      <textarea v-model="commentaire" cols="30" rows="10" placeholder="Vos suggestions..."></textarea>
      <button @click="envoyer">Envoyer</button>
    </div>

    <!-- Modèles de confirmation et d'accès si nécessaire -->
    <ConfirmationModel
      v-if="flagConfirmation"
      :text="textConfirmation"
      @closeConfirmation="closeConfirmation"
      @validerConfirmation="validerConfirmation"
    />
    <NotAccessPageModel
      v-if="flagNotAccess"
      :text="textNotAccess"
    />
    
  </div>
</template>

<script>
import ConfirmationModel from "@/components/models/ConfirmationModel.vue";
import NotAccessPageModel from "@/components/models/NotAccessPageModel.vue";
import Satisfaction from "@/connection/Satisfaction";
import Urls from "@/connection/Urls";

export default {
  name: "EnqueteSatisfaction",
  components: { ConfirmationModel, NotAccessPageModel },
  data() {
    return {
      // Informations client
      raisonSocial: null,
      secteurActivite: null,
      secteurActiviteAutre: "",
      nomEvaluateur: null,
      prenomEvaluateur: null,
      fonctionEvaluateur: null,
      telephoneEvaluateur: null,
      emailEvaluateur: null,
      lieuEnvoyer: null,
      dateEnvoyer: null,
      secteurs : [
            "Agriculture",
            "Automobile",
            "Banque et Finance",
            "Éducation",
            "Énergie",
            "Santé",
            "Technologies",
            "Tourisme",
            "Commerce",
            "Construction",
            "Télécommunications",
            "Immobilier",
            "Industrie",
            "Transports et Logistique",
            "Média et Publicité",
            "Assurances",
            "Hôtellerie",
            "Alimentation et Boissons",
            "Mode et Textile",
            "Arts et Culture",
            "Environnement",
            "Pharmaceutique",
            "Cosmétiques",
            "Événementiel",
            "Sport",
            "Recrutement et Emploi",
            "Consulting et Services professionnels",
            "Ressources humaines",
            "Aérospatiale",
            "Défense",
            "Technologies de l'information et de la communication (TIC)",
            "Finance et Comptabilité",
            "Vente au détail",
            "Distribution",
            "BTP (Bâtiment et Travaux Publics)",
            "Sciences et Recherche",
            "Électronique",
            "Informatique et Logiciels",
            "Équipements industriels",
            "Transport maritime",
            "Transport aérien",
            "Transport ferroviaire",
            "Sécurité",
            "Médias numériques",
            "Logistique et Chaîne d'approvisionnement",
            "Services publics",
            "Tourisme durable",
            "Technologies vertes",
            "Services à la personne",
            "Juridique",
            "Réseaux sociaux",
            "E-commerce",
            "Développement durable",
            "Aéronautique",
            "Biotechnologie",
            "Industrie minière",
            "Extraction de ressources naturelles",
            "Gestion des déchets",
            "Véhicules électriques",
            "Télévision et cinéma",
            "Radio",
            "Photographie",
            "Musique",
            "Mode et Luxe",
            "Vêtements et Accessoires",
            "Parfumerie",
            "Bijoux",
            "Papeterie",
            "Meubles",
            "Peinture et Décoration",
            "Plomberie",
            "Electricité",
            "Systèmes de sécurité",
            "Jardinage",
            "Construction navale",
            "Mécanique",
            "Maintenance industrielle",
            "Microélectronique",
            "Impression",
            "Packaging",
            "Exploitation forestière",
            "Vins et Spiritueux",
            "Commerce de gros",
            "Commerce de détail alimentaire",
            "Commerce de détail non alimentaire",
            "Services financiers",
            "Gestion d'actifs",
            "Comptabilité et audit",
            "Caisse d'épargne",
            "Banques d'investissement",
            "Microfinance",
            "Crowdfunding",
            "Mécénat",
            "Blockchain et Cryptomonnaies",
            "Agriculture bio",
            "Agriculture urbaine",
            "Finance durable",
            "Investissements éthiques",
            "Agriculture de précision",
            "Sécurité alimentaire",
            "Vente de produits artisanaux",
            "Internet des objets (IoT)",
            "Cyber-sécurité",
            "Data science et Big Data",
            "Machine Learning et IA",
            "Technologies 5G",
            "Blockchain",
            "Cloud computing",
            "Énergies renouvelables",
            "Économie circulaire",
            "E-commerce de niche",
            "Services d'abonnement",
            "Génie génétique",
            "Robotiques",
            "Automatisation industrielle",
            "Technologies d'impression 3D",
            "Conception UX/UI",
            "Création de contenu numérique",
            "Marketing digital",
            "Publicité en ligne",
            "Influenceurs",
            "Agences de communication",
            "Gestion de patrimoine",
            "Capital-risque",
            "Fintech",
            "Legaltech",
            "Medtech",
            "Regtech",
            "Edtech",
            "Proptech",
            "Art et antiquités",
            "Édition et publications",
            "Bibliothèques et archives",
            "Recherche et développement",
            "Matériaux composites",
            "Nanotechnologies",
            "Comptabilité",
            "Ressources naturelles",
            "Commerce international",
            "Import-Export",
            "Soutien aux entreprises",
            "Coaching professionnel",
            "Formation en entreprise",
            "Santé mentale",
            "Prévention santé",
            "Médecine alternative",
            "Soins infirmiers",
            "Médecine préventive",
            "Génie civil",
            "Services de traduction",
            "Service client",
            "Gestion de projets",
            "Évaluation immobilière",
            "Gestion de flotte",
            "Conseil en stratégie",
            "Accompagnement business",
            "Startups et incubation",
            "Développement d'applications mobiles",
            "Création de logiciels",
            "Développement web",
            "Intelligence artificielle"
       ],
      // Variables pour "sources"
      sources: ["Recommandation", "Site internet", "Mailing", "Avis en ligne", "Recherche", "Bouche-à-oreille", "Autre"],
      source: null,
      sourceAutre: "",

      // Variables pour "prestations"
      prestations: [
        { text: "Prestations de contrôle règlementaire", value: false },
        { text: "Prestations d’assistance technique", value: false },
        { text: "Prestations des formations", value: false },
        { text: "Autre", value: false }
      ],
      autrePrestationDetail: "",

      // Boutons d'échelle (satisfaction globale)
      isDefaultButtonColorRecommandation: "is-default-button-color",
      isDefaultButtonColorNeutre: "is-default-button-color",
      isDefaultButtonColorPasRecommandation: "is-default-button-color",
      echelleSelect: null,

      // Boutons de recommandation entreprise
      isDefaultButtonColorRecommandationEntreprise: "is-default-button-color",
      isDefaultButtonColorNeutreEntreprise: "is-default-button-color",
      isDefaultButtonColorPasRecommandationEntreprise: "is-default-button-color",
      entreprise: null,

      // Questions d'évaluation détaillée
      questions: [
        { id: 1, question: "Réactivité de notre équipe face à vos demandes ?", note: null },
        { id: 2, question: "Qualité des prestations fournies ?", note: null },
        { id: 3, question: "Qualité de nos inspecteurs/formateurs ?", note: null },
        { id: 4, question: "Qualité de nos rapports et livrables ?", note: null },
        { id: 5, question: "Pertinence des recommandations et observations ?", note: null },
        { id: 6, question: "Votre avis sur nos solutions technologiques (E-GTH CLIENT, Espace Client, Espace Documentation, etc.) ?", note: null }
      ],

      // Commentaires et Flags
      commentaire: "",
      flagConfirmation: false,
      textConfirmation: "",
      flagNotAccess: false,
      textNotAccess: "",
      // Autres variables issues d'une lecture (exemple d'URL et données client)
      id: null,
      pathUrl: null
    };
  },
  computed: {
    // Vérifie si la prestation "Autre" est sélectionnée
    prestationAutreSelected() {
      const prestation = this.prestations.find(item => item.text === "Autre");
      return prestation ? prestation.value : false;
    }
  },
  methods: {
    /* Méthodes pour la satisfaction globale */
    changeColorRecommandation() {
      this.isDefaultButtonColorRecommandation = 'is-green-color';
      this.isDefaultButtonColorNeutre = 'is-default-button-color';
      this.isDefaultButtonColorPasRecommandation = 'is-default-button-color';
      this.echelleSelect = "Satisfait";
    },
    changeColorNeutre() {
      this.isDefaultButtonColorRecommandation = 'is-default-button-color';
      this.isDefaultButtonColorNeutre = 'is-grey-color';
      this.isDefaultButtonColorPasRecommandation = 'is-default-button-color';
      this.echelleSelect = "Moyennement satisfait";
    },
    changeColorPasRecommandation() {
      this.isDefaultButtonColorRecommandation = 'is-default-button-color';
      this.isDefaultButtonColorNeutre = 'is-default-button-color';
      this.isDefaultButtonColorPasRecommandation = 'is-red-color';
      this.echelleSelect = "Non satisfait";
    },
    /* Méthodes pour la recommandation entreprise */
    changeColorRecommandationEntreprise() {
      this.isDefaultButtonColorRecommandationEntreprise = 'is-green-color';
      this.isDefaultButtonColorNeutreEntreprise = 'is-default-button-color';
      this.isDefaultButtonColorPasRecommandationEntreprise = 'is-default-button-color';
      this.entreprise = "Oui";
    },
    changeColorNeutreEntreprise() {
      this.isDefaultButtonColorRecommandationEntreprise = 'is-default-button-color';
      this.isDefaultButtonColorNeutreEntreprise = 'is-green-color';
      this.isDefaultButtonColorPasRecommandationEntreprise = 'is-default-button-color';
      this.entreprise = "Peut-être";
    },
    changeColorPasRecommandationEntreprise() {
      this.isDefaultButtonColorRecommandationEntreprise = 'is-default-button-color';
      this.isDefaultButtonColorNeutreEntreprise = 'is-default-button-color';
      this.isDefaultButtonColorPasRecommandationEntreprise = 'is-green-color';
      this.entreprise = "Non";
    },
    envoyer() {
      // Affiche un modal de confirmation
      this.textConfirmation = "Êtes-vous sûr des informations saisies ?";
      this.flagConfirmation = true;
    },
    closeConfirmation() {
      this.flagConfirmation = false;
      window.open('', '_self').close();
    },
    validerConfirmation() {
      this.flagConfirmation = false;
      // Exemple d'appel à un service backend pour envoyer les données
      Satisfaction.envoyer(
        this.id,
        this.raisonSocial,
        this.secteurActivite,
        this.secteurActiviteAutre,
        this.nomEvaluateur,
        this.prenomEvaluateur,
        this.fonctionEvaluateur,
        this.telephoneEvaluateur,
        this.emailEvaluateur,
        this.lieuEnvoyer,
        this.dateEnvoyer,
        this.questions,
        this.commentaire,
        this.echelleSelect,
        this.source,
        this.sourceAutre,
        this.prestations,
        this.autrePrestationDetail,
        this.entreprise
      )
        .then((result) => {
          if(result.data.cas == true) {
            window.open('', '_self').close();
          } 
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },
  mounted() {
    // Lecture des paramètres d'URL (exemple)
    const { pathUrl } = this.$route.params;
    
    Urls.read(pathUrl)
      .then((result) => {

        if (result.data.url == null) {
          this.textNotAccess = "Nous sommes désolés, l'enquête est actuellement indisponible. Merci de votre compréhension";
        } else {
          this.id = result.data.url._id;
          this.pathUrl = result.data.url.pathUrl;
          this.raisonSocial = result.data.url.raisonSocial;
          // Affectation des autres données client...
          this.emailEvaluateur = result.data.url.email;
        }
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
};
</script>

<style scoped>
.parent {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  color: #243064;
}

/* En-tête */
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.header .logo {
  height: 80px;
}
.header .titre {
  font-size: 1.8rem;
  font-weight: bold;
}
.header .reference {
  list-style: none;
  padding: 0;
}

/* Barres de séparation */
.barr,
.barr-question {
  background-color: #243064;
  margin: 20px 0;
  padding: 5px;
  color: #fff;
  text-align: center;
  font-weight: bold;
}

/* Introduction */
.itresse {
  text-align: center;
}
.itresse h3 {
  font-size: 1.6rem;
  color: #d9534f;
}

/* Informations client */
.client {
  list-style: none;
  padding: 0;
}
.client li {
  margin: 10px 0;
}
.client input,
.client select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Tableau des questions */
#customers {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
#customers th,
#customers td {
  border: 1px solid #ddd;
  padding: 8px;
}
#customers th {
  background-color: #f13809;
  color: #fff;
}

#app > div:nth-child(6) > ul > li:nth-child(11) > input[type=text] {
  margin-top: 5px;
}

#customers > tr:nth-child(7) > td:nth-child(1) {
  letter-spacing: 0px;
  word-spacing: 6px;
}

/* Boutons d'échelle */
.echelle {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}
.echelle li {
  list-style: none;
  padding: 16px 20px;
  margin: 0 5px;
  font-size: 1rem;
  border-radius: 20px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.3s;
}
.is-default-button-color {
  background-color: rgb(36, 117, 238);
  color: #fff;
}
.is-default-button-color:hover {
  background-color: #000;
}
.is-green-color {
  background-color: green;
  color: #fff;
}
.is-red-color {
  background-color: red;
  color: #fff;
}
.is-grey-color {
  background-color: grey;
  color: #fff;
}

/* Commentaires */
.commentaires {
  margin-top: 20px;
  text-align: center;
}
.commentaires textarea {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  resize: vertical;
}
.commentaires button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #d9534f;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}
.commentaires button:hover {
  background-color: #c9302c;
}
</style>
